var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"niste-clan"},[_c('div',[_vm._v("Niste član ovog projekta. Javite se voditelju da vam omogući pristup.")]),_c('router-link',{attrs:{"to":"/projects"}},[_vm._v("Povrat na popis")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }